/**
 * Copyright IBM Corp. 2022, 2026
 */

import Image from 'next/legacy/image'
import { FlightIcon } from '@hashicorp/mds-react/components'
import s from './speaker.module.css'

export default function Speaker({
	name,
	description,
	companyName,
	photo,
	social,
}) {
	return (
		<div className={s.speaker}>
			{photo ? (
				<div className={s.speakerImageFrame}>
					<Image
						src={photo.url}
						width={photo.width}
						height={photo.height}
						alt={name}
					/>
				</div>
			) : (
				<div className={s.speakerInitials}>
					<span className={s.speakerInitialsText}>{getInitials(name)}</span>
				</div>
			)}
			<div className={s.info}>
				<h5 className={`g-type-display-5 ${s.name}`}>{name}</h5>
				<p className={`g-type-body-small ${s.description}`}>
					{description}
					{companyName && `, ${companyName}`}
				</p>
				<div className={s.social}>
					{social &&
						social.length > 0 &&
						social.map(({ networkName, url }) => {
							return (
								<a
									href={url}
									key={networkName}
									target="_blank"
									rel="noreferrer"
								>
									<FlightIcon
										title={`${networkName} icon`}
										name={networkName}
										className={s.socialIcon}
										size={24}
										color="var(--gray-2)"
									/>
								</a>
							)
						})}
				</div>
			</div>
		</div>
	)
}

// Returns the first letters of the first and last names. Returns a single letter if
// one word is provided.
function getInitials(name) {
	return name
		.trim()
		.split(/ +/g)
		.filter((n, i, a) => i === 0 || i === a.length - 1) // Get first and last words of name
		.reduce((acc, name) => acc + name[0], '') // Get first letters of each word
		.toUpperCase()
}
